const { handleError, handleResponse, api } = require("./baseApi");

const api_config = require("./api_config");



function getMerchantsPageApi(page, size, category, requiredFields, platforms, shuffle) {
    let queryArray = [];
    if (page) queryArray.push("page=" + page);
    if (size) queryArray.push("size=" + size);
    if (category) queryArray.push("category=" + category);
    if (shuffle) queryArray.push("shuffle=true");
    if (requiredFields) {
        requiredFields.forEach(field => queryArray.push("requiredFields=" + field))
    }
    if (platforms) {
        platforms.forEach(platform => queryArray.push("platforms=" + platform))
    }
    let queryString = queryArray.length ? '?'+queryArray.join("&") : "";

    return api.get(
        `/merchants/v1${queryString}`,
        {headers: {"x-api-key": `${api_config.carbon_app_api_key}`}}
    )
        .then(handleResponse)
        .catch(handleError)
}

function getMerchantsCountApi() {
    return api.get(
        `/merchants/v1/count`,
        {headers: {"x-api-key": `${api_config.carbon_app_api_key}`}}
    )
        .then(handleResponse)
        .catch(handleError)
}

function getMerchantByCodeApi(code) {
    return api.get(
        `/merchants/v1/${code}`,
        { headers: { "x-api-key": `${api_config.carbon_app_api_key}` } }
    )
        .then(handleResponse)
        .catch(handleError)
}

function getMerchantByIdApi(id, pledgeTaken) {
    let queryArray = [];
    if (pledgeTaken) queryArray.push("showHasPledged=" + pledgeTaken);
    let queryString = queryArray.length ? '?' + queryArray.join("&") : "";

    return api.get(
        `/merchants/v1/${id}${queryString}`,
        { headers: { "x-api-key": `${api_config.carbon_app_api_key}` } }
    )
        .then(handleResponse)
        .catch(handleError)
}

function createMerchantApi(data) {
    return api.post(
        `/merchants/v1/`, JSON.stringify(data),
        { headers: { "x-api-key": `${api_config.carbon_app_api_key}` } }
    )
        .then(handleResponse)
        .catch(handleError)
}

function createMerchantUserApi(code, data) {
    return api.post(
        `/merchants/v1/${code}/users`, JSON.stringify(data),
        { headers: { "x-api-key": `${api_config.carbon_app_api_key}` } }
    )
        .then(handleResponse)
        .catch(handleError)
}

function climatePledgeForMerchantApi(code, pledgeTaken) {
    return api.patch(
        `/merchants/v1/${code}`, JSON.stringify({ pledgeTaken}),
        { headers: { "x-api-key": `${api_config.carbon_app_api_key}` } }
    )
        .then(handleResponse)
        .catch(handleError)
}

function industryCodeForMerchantApi(code, industryCode) {
    return api.patch(
        `/merchants/v1/${code}`, JSON.stringify({ industryCode }),
        { headers: { "x-api-key": `${api_config.carbon_app_api_key}` } }
    )
        .then(handleResponse)
        .catch(handleError)
}


module.exports = { getMerchantsPageApi, getMerchantsCountApi, getMerchantByCodeApi, createMerchantApi, createMerchantUserApi, getMerchantByIdApi, climatePledgeForMerchantApi, industryCodeForMerchantApi };
